import { default as indexFbcckpnQk9Meta } from "/var/www/pecom.am/www/frontend/pages/[page]/index.vue?macro=true";
import { default as aboutvVdtvmPC6lMeta } from "/var/www/pecom.am/www/frontend/pages/about.vue?macro=true";
import { default as hidden_indexy2j2cfhl7jMeta } from "/var/www/pecom.am/www/frontend/pages/documents/hidden_index.vue?macro=true";
import { default as errorDPvM4TJfqcMeta } from "/var/www/pecom.am/www/frontend/pages/error.vue?macro=true";
import { default as BlockFaqVDwrz96XAAMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/BlockFaq.vue?macro=true";
import { default as ConsultationBlockZbYofNCbUZMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationBlock.vue?macro=true";
import { default as ConsultationFormF49I3neDaqMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationForm.vue?macro=true";
import { default as FilialOpentyPZdkiKhhMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/FilialOpen.vue?macro=true";
import { default as FranchiseBlockQWM63De0gUMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/FranchiseBlock.vue?macro=true";
import { default as MapBlockSYQYabHQdHMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue?macro=true";
import { default as PalletBlockrfpxEdcnxLMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue?macro=true";
import { default as ModalErrorQIzUlnTC8dMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/ModalError.vue?macro=true";
import { default as ModalSuccess1zBlGpgBDGMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/ModalSuccess.vue?macro=true";
import { default as PalletBlockzynG0tw6jhMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletBlock.vue?macro=true";
import { default as PalletOneJR768VKLhaMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletOne.vue?macro=true";
import { default as BlockDescriptionfaqVLxCmSuMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue?macro=true";
import { default as PartnersBlock1AAZWGAPbGMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue?macro=true";
import { default as PalletBlockdowxSBIKdNMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue?macro=true";
import { default as PekPlusBlockA2BR9lLQYCMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue?macro=true";
import { default as indexo4gH0Sk3DRMeta } from "/var/www/pecom.am/www/frontend/pages/franchise/index.vue?macro=true";
import { default as AdvantageBlockAH0EVuhcHGMeta } from "/var/www/pecom.am/www/frontend/pages/index/components/AdvantageBlock.vue?macro=true";
import { default as BannerSliderNxg8kW4CTzMeta } from "/var/www/pecom.am/www/frontend/pages/index/components/BannerSlider.vue?macro=true";
import { default as BlockTitlevPbBXcQ4u4Meta } from "/var/www/pecom.am/www/frontend/pages/index/components/BlockTitle.vue?macro=true";
import { default as ConsultationBlockOo4EUPyGMRMeta } from "/var/www/pecom.am/www/frontend/pages/index/components/ConsultationBlock.vue?macro=true";
import { default as ConsultationFormamZTqFcpLvMeta } from "/var/www/pecom.am/www/frontend/pages/index/components/ConsultationForm.vue?macro=true";
import { default as ModalErrorw8eQtoZ2pMMeta } from "/var/www/pecom.am/www/frontend/pages/index/components/ModalError.vue?macro=true";
import { default as ModalSuccessUUfJgxVefbMeta } from "/var/www/pecom.am/www/frontend/pages/index/components/ModalSuccess.vue?macro=true";
import { default as indexQki3eD8v5aMeta } from "/var/www/pecom.am/www/frontend/pages/index/index.vue?macro=true";
import { default as DefaultAdvantagesSection1AFZ6zFr1zMeta } from "/var/www/pecom.am/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue?macro=true";
import { default as DefaultHeaderSectionudrYYBu1sOMeta } from "/var/www/pecom.am/www/frontend/pages/index/sections/DefaultHeaderSection.vue?macro=true";
import { default as DescriptionSectionSg4nfRLbdDMeta } from "/var/www/pecom.am/www/frontend/pages/index/sections/DescriptionSection.vue?macro=true";
import { default as FaqSectionNxUCLl004aMeta } from "/var/www/pecom.am/www/frontend/pages/index/sections/FaqSection.vue?macro=true";
import { default as InfoSectionrI6mYqJstZMeta } from "/var/www/pecom.am/www/frontend/pages/index/sections/InfoSection.vue?macro=true";
import { default as MapSection9FYkEwe3gNMeta } from "/var/www/pecom.am/www/frontend/pages/index/sections/MapSection.vue?macro=true";
import { default as getAddressInfohkZLymObShMeta } from "/var/www/pecom.am/www/frontend/pages/index/utils/getAddressInfo.js?macro=true";
import { default as getDirectionParamsFromAddressInfoWMpkquWxkhMeta } from "/var/www/pecom.am/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js?macro=true";
import { default as getNeedCalculatelIKzwVQrXQMeta } from "/var/www/pecom.am/www/frontend/pages/index/utils/getNeedCalculate.js?macro=true";
import { default as getSugggestAmwz4bznMkMeta } from "/var/www/pecom.am/www/frontend/pages/index/utils/getSugggest.js?macro=true";
import { default as getTransitCostBlockMessageRqeVp9RWiQMeta } from "/var/www/pecom.am/www/frontend/pages/index/utils/getTransitCostBlockMessage.js?macro=true";
import { default as isProductCodeU4uiEf2eXpMeta } from "/var/www/pecom.am/www/frontend/pages/index/utils/isProductCode.js?macro=true";
import { default as _91id_9372B1km1bFBMeta } from "/var/www/pecom.am/www/frontend/pages/news/[id].vue?macro=true";
import { default as indexCgQk0w04xcMeta } from "/var/www/pecom.am/www/frontend/pages/news/index.vue?macro=true";
import { default as Category5o7lwb8Dm8Meta } from "/var/www/pecom.am/www/frontend/pages/package/components/Category.vue?macro=true";
import { default as CategoryPalletFWtshR6M0AMeta } from "/var/www/pecom.am/www/frontend/pages/package/components/CategoryPallet.vue?macro=true";
import { default as PalletBlockESgtCrYfKfMeta } from "/var/www/pecom.am/www/frontend/pages/package/components/PalletBlock.vue?macro=true";
import { default as HeadWithSearch1wJjSmHIfsMeta } from "/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue?macro=true";
import { default as TableBlock3FzEbDyGhgMeta } from "/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableBlock.vue?macro=true";
import { default as TableRow0zfH4AUUw3Meta } from "/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableRow.vue?macro=true";
import { default as TableSearchbGV6TAzil3Meta } from "/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableSearch.vue?macro=true";
import { default as index3iPLGMVd8RMeta } from "/var/www/pecom.am/www/frontend/pages/package/index.vue?macro=true";
export default [
  {
    name: indexFbcckpnQk9Meta?.name ?? "page___hy",
    path: indexFbcckpnQk9Meta?.path ?? "/:page()",
    meta: indexFbcckpnQk9Meta || {},
    alias: indexFbcckpnQk9Meta?.alias || [],
    redirect: indexFbcckpnQk9Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFbcckpnQk9Meta?.name ?? "page___en",
    path: indexFbcckpnQk9Meta?.path ?? "/en/:page()",
    meta: indexFbcckpnQk9Meta || {},
    alias: indexFbcckpnQk9Meta?.alias || [],
    redirect: indexFbcckpnQk9Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFbcckpnQk9Meta?.name ?? "page___ru",
    path: indexFbcckpnQk9Meta?.path ?? "/ru/:page()",
    meta: indexFbcckpnQk9Meta || {},
    alias: indexFbcckpnQk9Meta?.alias || [],
    redirect: indexFbcckpnQk9Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: aboutvVdtvmPC6lMeta?.name ?? "about___hy",
    path: aboutvVdtvmPC6lMeta?.path ?? "/about",
    meta: aboutvVdtvmPC6lMeta || {},
    alias: aboutvVdtvmPC6lMeta?.alias || [],
    redirect: aboutvVdtvmPC6lMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/about.vue").then(m => m.default || m)
  },
  {
    name: aboutvVdtvmPC6lMeta?.name ?? "about___en",
    path: aboutvVdtvmPC6lMeta?.path ?? "/en/about",
    meta: aboutvVdtvmPC6lMeta || {},
    alias: aboutvVdtvmPC6lMeta?.alias || [],
    redirect: aboutvVdtvmPC6lMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/about.vue").then(m => m.default || m)
  },
  {
    name: aboutvVdtvmPC6lMeta?.name ?? "about___ru",
    path: aboutvVdtvmPC6lMeta?.path ?? "/ru/about",
    meta: aboutvVdtvmPC6lMeta || {},
    alias: aboutvVdtvmPC6lMeta?.alias || [],
    redirect: aboutvVdtvmPC6lMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/about.vue").then(m => m.default || m)
  },
  {
    name: hidden_indexy2j2cfhl7jMeta?.name ?? "documents-hidden_index___hy",
    path: hidden_indexy2j2cfhl7jMeta?.path ?? "/documents/hidden_index",
    meta: hidden_indexy2j2cfhl7jMeta || {},
    alias: hidden_indexy2j2cfhl7jMeta?.alias || [],
    redirect: hidden_indexy2j2cfhl7jMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/documents/hidden_index.vue").then(m => m.default || m)
  },
  {
    name: hidden_indexy2j2cfhl7jMeta?.name ?? "documents-hidden_index___en",
    path: hidden_indexy2j2cfhl7jMeta?.path ?? "/en/documents/hidden_index",
    meta: hidden_indexy2j2cfhl7jMeta || {},
    alias: hidden_indexy2j2cfhl7jMeta?.alias || [],
    redirect: hidden_indexy2j2cfhl7jMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/documents/hidden_index.vue").then(m => m.default || m)
  },
  {
    name: hidden_indexy2j2cfhl7jMeta?.name ?? "documents-hidden_index___ru",
    path: hidden_indexy2j2cfhl7jMeta?.path ?? "/ru/documents/hidden_index",
    meta: hidden_indexy2j2cfhl7jMeta || {},
    alias: hidden_indexy2j2cfhl7jMeta?.alias || [],
    redirect: hidden_indexy2j2cfhl7jMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/documents/hidden_index.vue").then(m => m.default || m)
  },
  {
    name: errorDPvM4TJfqcMeta?.name ?? "error___hy",
    path: errorDPvM4TJfqcMeta?.path ?? "/error",
    meta: errorDPvM4TJfqcMeta || {},
    alias: errorDPvM4TJfqcMeta?.alias || [],
    redirect: errorDPvM4TJfqcMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/error.vue").then(m => m.default || m)
  },
  {
    name: errorDPvM4TJfqcMeta?.name ?? "error___en",
    path: errorDPvM4TJfqcMeta?.path ?? "/en/error",
    meta: errorDPvM4TJfqcMeta || {},
    alias: errorDPvM4TJfqcMeta?.alias || [],
    redirect: errorDPvM4TJfqcMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/error.vue").then(m => m.default || m)
  },
  {
    name: errorDPvM4TJfqcMeta?.name ?? "error___ru",
    path: errorDPvM4TJfqcMeta?.path ?? "/ru/error",
    meta: errorDPvM4TJfqcMeta || {},
    alias: errorDPvM4TJfqcMeta?.alias || [],
    redirect: errorDPvM4TJfqcMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/error.vue").then(m => m.default || m)
  },
  {
    name: BlockFaqVDwrz96XAAMeta?.name ?? "franchise-components-BlockFaq___hy",
    path: BlockFaqVDwrz96XAAMeta?.path ?? "/franchise/components/BlockFaq",
    meta: BlockFaqVDwrz96XAAMeta || {},
    alias: BlockFaqVDwrz96XAAMeta?.alias || [],
    redirect: BlockFaqVDwrz96XAAMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/BlockFaq.vue").then(m => m.default || m)
  },
  {
    name: BlockFaqVDwrz96XAAMeta?.name ?? "franchise-components-BlockFaq___en",
    path: BlockFaqVDwrz96XAAMeta?.path ?? "/en/franchise/components/BlockFaq",
    meta: BlockFaqVDwrz96XAAMeta || {},
    alias: BlockFaqVDwrz96XAAMeta?.alias || [],
    redirect: BlockFaqVDwrz96XAAMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/BlockFaq.vue").then(m => m.default || m)
  },
  {
    name: BlockFaqVDwrz96XAAMeta?.name ?? "franchise-components-BlockFaq___ru",
    path: BlockFaqVDwrz96XAAMeta?.path ?? "/ru/franchise/components/BlockFaq",
    meta: BlockFaqVDwrz96XAAMeta || {},
    alias: BlockFaqVDwrz96XAAMeta?.alias || [],
    redirect: BlockFaqVDwrz96XAAMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/BlockFaq.vue").then(m => m.default || m)
  },
  {
    name: ConsultationBlockZbYofNCbUZMeta?.name ?? "franchise-components-ConsultationBlock___hy",
    path: ConsultationBlockZbYofNCbUZMeta?.path ?? "/franchise/components/ConsultationBlock",
    meta: ConsultationBlockZbYofNCbUZMeta || {},
    alias: ConsultationBlockZbYofNCbUZMeta?.alias || [],
    redirect: ConsultationBlockZbYofNCbUZMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationBlock.vue").then(m => m.default || m)
  },
  {
    name: ConsultationBlockZbYofNCbUZMeta?.name ?? "franchise-components-ConsultationBlock___en",
    path: ConsultationBlockZbYofNCbUZMeta?.path ?? "/en/franchise/components/ConsultationBlock",
    meta: ConsultationBlockZbYofNCbUZMeta || {},
    alias: ConsultationBlockZbYofNCbUZMeta?.alias || [],
    redirect: ConsultationBlockZbYofNCbUZMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationBlock.vue").then(m => m.default || m)
  },
  {
    name: ConsultationBlockZbYofNCbUZMeta?.name ?? "franchise-components-ConsultationBlock___ru",
    path: ConsultationBlockZbYofNCbUZMeta?.path ?? "/ru/franchise/components/ConsultationBlock",
    meta: ConsultationBlockZbYofNCbUZMeta || {},
    alias: ConsultationBlockZbYofNCbUZMeta?.alias || [],
    redirect: ConsultationBlockZbYofNCbUZMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationBlock.vue").then(m => m.default || m)
  },
  {
    name: ConsultationFormF49I3neDaqMeta?.name ?? "franchise-components-ConsultationForm___hy",
    path: ConsultationFormF49I3neDaqMeta?.path ?? "/franchise/components/ConsultationForm",
    meta: ConsultationFormF49I3neDaqMeta || {},
    alias: ConsultationFormF49I3neDaqMeta?.alias || [],
    redirect: ConsultationFormF49I3neDaqMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationForm.vue").then(m => m.default || m)
  },
  {
    name: ConsultationFormF49I3neDaqMeta?.name ?? "franchise-components-ConsultationForm___en",
    path: ConsultationFormF49I3neDaqMeta?.path ?? "/en/franchise/components/ConsultationForm",
    meta: ConsultationFormF49I3neDaqMeta || {},
    alias: ConsultationFormF49I3neDaqMeta?.alias || [],
    redirect: ConsultationFormF49I3neDaqMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationForm.vue").then(m => m.default || m)
  },
  {
    name: ConsultationFormF49I3neDaqMeta?.name ?? "franchise-components-ConsultationForm___ru",
    path: ConsultationFormF49I3neDaqMeta?.path ?? "/ru/franchise/components/ConsultationForm",
    meta: ConsultationFormF49I3neDaqMeta || {},
    alias: ConsultationFormF49I3neDaqMeta?.alias || [],
    redirect: ConsultationFormF49I3neDaqMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ConsultationForm.vue").then(m => m.default || m)
  },
  {
    name: FilialOpentyPZdkiKhhMeta?.name ?? "franchise-components-FilialOpen___hy",
    path: FilialOpentyPZdkiKhhMeta?.path ?? "/franchise/components/FilialOpen",
    meta: FilialOpentyPZdkiKhhMeta || {},
    alias: FilialOpentyPZdkiKhhMeta?.alias || [],
    redirect: FilialOpentyPZdkiKhhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/FilialOpen.vue").then(m => m.default || m)
  },
  {
    name: FilialOpentyPZdkiKhhMeta?.name ?? "franchise-components-FilialOpen___en",
    path: FilialOpentyPZdkiKhhMeta?.path ?? "/en/franchise/components/FilialOpen",
    meta: FilialOpentyPZdkiKhhMeta || {},
    alias: FilialOpentyPZdkiKhhMeta?.alias || [],
    redirect: FilialOpentyPZdkiKhhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/FilialOpen.vue").then(m => m.default || m)
  },
  {
    name: FilialOpentyPZdkiKhhMeta?.name ?? "franchise-components-FilialOpen___ru",
    path: FilialOpentyPZdkiKhhMeta?.path ?? "/ru/franchise/components/FilialOpen",
    meta: FilialOpentyPZdkiKhhMeta || {},
    alias: FilialOpentyPZdkiKhhMeta?.alias || [],
    redirect: FilialOpentyPZdkiKhhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/FilialOpen.vue").then(m => m.default || m)
  },
  {
    name: FranchiseBlockQWM63De0gUMeta?.name ?? "franchise-components-FranchiseBlock___hy",
    path: FranchiseBlockQWM63De0gUMeta?.path ?? "/franchise/components/FranchiseBlock",
    meta: FranchiseBlockQWM63De0gUMeta || {},
    alias: FranchiseBlockQWM63De0gUMeta?.alias || [],
    redirect: FranchiseBlockQWM63De0gUMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/FranchiseBlock.vue").then(m => m.default || m)
  },
  {
    name: FranchiseBlockQWM63De0gUMeta?.name ?? "franchise-components-FranchiseBlock___en",
    path: FranchiseBlockQWM63De0gUMeta?.path ?? "/en/franchise/components/FranchiseBlock",
    meta: FranchiseBlockQWM63De0gUMeta || {},
    alias: FranchiseBlockQWM63De0gUMeta?.alias || [],
    redirect: FranchiseBlockQWM63De0gUMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/FranchiseBlock.vue").then(m => m.default || m)
  },
  {
    name: FranchiseBlockQWM63De0gUMeta?.name ?? "franchise-components-FranchiseBlock___ru",
    path: FranchiseBlockQWM63De0gUMeta?.path ?? "/ru/franchise/components/FranchiseBlock",
    meta: FranchiseBlockQWM63De0gUMeta || {},
    alias: FranchiseBlockQWM63De0gUMeta?.alias || [],
    redirect: FranchiseBlockQWM63De0gUMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/FranchiseBlock.vue").then(m => m.default || m)
  },
  {
    name: MapBlockSYQYabHQdHMeta?.name ?? "franchise-components-mapBlock-MapBlock___hy",
    path: MapBlockSYQYabHQdHMeta?.path ?? "/franchise/components/mapBlock/MapBlock",
    meta: MapBlockSYQYabHQdHMeta || {},
    alias: MapBlockSYQYabHQdHMeta?.alias || [],
    redirect: MapBlockSYQYabHQdHMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue").then(m => m.default || m)
  },
  {
    name: MapBlockSYQYabHQdHMeta?.name ?? "franchise-components-mapBlock-MapBlock___en",
    path: MapBlockSYQYabHQdHMeta?.path ?? "/en/franchise/components/mapBlock/MapBlock",
    meta: MapBlockSYQYabHQdHMeta || {},
    alias: MapBlockSYQYabHQdHMeta?.alias || [],
    redirect: MapBlockSYQYabHQdHMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue").then(m => m.default || m)
  },
  {
    name: MapBlockSYQYabHQdHMeta?.name ?? "franchise-components-mapBlock-MapBlock___ru",
    path: MapBlockSYQYabHQdHMeta?.path ?? "/ru/franchise/components/mapBlock/MapBlock",
    meta: MapBlockSYQYabHQdHMeta || {},
    alias: MapBlockSYQYabHQdHMeta?.alias || [],
    redirect: MapBlockSYQYabHQdHMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockrfpxEdcnxLMeta?.name ?? "franchise-components-mapBlock-PalletBlock___hy",
    path: PalletBlockrfpxEdcnxLMeta?.path ?? "/franchise/components/mapBlock/PalletBlock",
    meta: PalletBlockrfpxEdcnxLMeta || {},
    alias: PalletBlockrfpxEdcnxLMeta?.alias || [],
    redirect: PalletBlockrfpxEdcnxLMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockrfpxEdcnxLMeta?.name ?? "franchise-components-mapBlock-PalletBlock___en",
    path: PalletBlockrfpxEdcnxLMeta?.path ?? "/en/franchise/components/mapBlock/PalletBlock",
    meta: PalletBlockrfpxEdcnxLMeta || {},
    alias: PalletBlockrfpxEdcnxLMeta?.alias || [],
    redirect: PalletBlockrfpxEdcnxLMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockrfpxEdcnxLMeta?.name ?? "franchise-components-mapBlock-PalletBlock___ru",
    path: PalletBlockrfpxEdcnxLMeta?.path ?? "/ru/franchise/components/mapBlock/PalletBlock",
    meta: PalletBlockrfpxEdcnxLMeta || {},
    alias: PalletBlockrfpxEdcnxLMeta?.alias || [],
    redirect: PalletBlockrfpxEdcnxLMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: ModalErrorQIzUlnTC8dMeta?.name ?? "franchise-components-ModalError___hy",
    path: ModalErrorQIzUlnTC8dMeta?.path ?? "/franchise/components/ModalError",
    meta: ModalErrorQIzUlnTC8dMeta || {},
    alias: ModalErrorQIzUlnTC8dMeta?.alias || [],
    redirect: ModalErrorQIzUlnTC8dMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ModalError.vue").then(m => m.default || m)
  },
  {
    name: ModalErrorQIzUlnTC8dMeta?.name ?? "franchise-components-ModalError___en",
    path: ModalErrorQIzUlnTC8dMeta?.path ?? "/en/franchise/components/ModalError",
    meta: ModalErrorQIzUlnTC8dMeta || {},
    alias: ModalErrorQIzUlnTC8dMeta?.alias || [],
    redirect: ModalErrorQIzUlnTC8dMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ModalError.vue").then(m => m.default || m)
  },
  {
    name: ModalErrorQIzUlnTC8dMeta?.name ?? "franchise-components-ModalError___ru",
    path: ModalErrorQIzUlnTC8dMeta?.path ?? "/ru/franchise/components/ModalError",
    meta: ModalErrorQIzUlnTC8dMeta || {},
    alias: ModalErrorQIzUlnTC8dMeta?.alias || [],
    redirect: ModalErrorQIzUlnTC8dMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ModalError.vue").then(m => m.default || m)
  },
  {
    name: ModalSuccess1zBlGpgBDGMeta?.name ?? "franchise-components-ModalSuccess___hy",
    path: ModalSuccess1zBlGpgBDGMeta?.path ?? "/franchise/components/ModalSuccess",
    meta: ModalSuccess1zBlGpgBDGMeta || {},
    alias: ModalSuccess1zBlGpgBDGMeta?.alias || [],
    redirect: ModalSuccess1zBlGpgBDGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ModalSuccess.vue").then(m => m.default || m)
  },
  {
    name: ModalSuccess1zBlGpgBDGMeta?.name ?? "franchise-components-ModalSuccess___en",
    path: ModalSuccess1zBlGpgBDGMeta?.path ?? "/en/franchise/components/ModalSuccess",
    meta: ModalSuccess1zBlGpgBDGMeta || {},
    alias: ModalSuccess1zBlGpgBDGMeta?.alias || [],
    redirect: ModalSuccess1zBlGpgBDGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ModalSuccess.vue").then(m => m.default || m)
  },
  {
    name: ModalSuccess1zBlGpgBDGMeta?.name ?? "franchise-components-ModalSuccess___ru",
    path: ModalSuccess1zBlGpgBDGMeta?.path ?? "/ru/franchise/components/ModalSuccess",
    meta: ModalSuccess1zBlGpgBDGMeta || {},
    alias: ModalSuccess1zBlGpgBDGMeta?.alias || [],
    redirect: ModalSuccess1zBlGpgBDGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/ModalSuccess.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockzynG0tw6jhMeta?.name ?? "franchise-components-pallet-PalletBlock___hy",
    path: PalletBlockzynG0tw6jhMeta?.path ?? "/franchise/components/pallet/PalletBlock",
    meta: PalletBlockzynG0tw6jhMeta || {},
    alias: PalletBlockzynG0tw6jhMeta?.alias || [],
    redirect: PalletBlockzynG0tw6jhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockzynG0tw6jhMeta?.name ?? "franchise-components-pallet-PalletBlock___en",
    path: PalletBlockzynG0tw6jhMeta?.path ?? "/en/franchise/components/pallet/PalletBlock",
    meta: PalletBlockzynG0tw6jhMeta || {},
    alias: PalletBlockzynG0tw6jhMeta?.alias || [],
    redirect: PalletBlockzynG0tw6jhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockzynG0tw6jhMeta?.name ?? "franchise-components-pallet-PalletBlock___ru",
    path: PalletBlockzynG0tw6jhMeta?.path ?? "/ru/franchise/components/pallet/PalletBlock",
    meta: PalletBlockzynG0tw6jhMeta || {},
    alias: PalletBlockzynG0tw6jhMeta?.alias || [],
    redirect: PalletBlockzynG0tw6jhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletOneJR768VKLhaMeta?.name ?? "franchise-components-pallet-PalletOne___hy",
    path: PalletOneJR768VKLhaMeta?.path ?? "/franchise/components/pallet/PalletOne",
    meta: PalletOneJR768VKLhaMeta || {},
    alias: PalletOneJR768VKLhaMeta?.alias || [],
    redirect: PalletOneJR768VKLhaMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletOne.vue").then(m => m.default || m)
  },
  {
    name: PalletOneJR768VKLhaMeta?.name ?? "franchise-components-pallet-PalletOne___en",
    path: PalletOneJR768VKLhaMeta?.path ?? "/en/franchise/components/pallet/PalletOne",
    meta: PalletOneJR768VKLhaMeta || {},
    alias: PalletOneJR768VKLhaMeta?.alias || [],
    redirect: PalletOneJR768VKLhaMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletOne.vue").then(m => m.default || m)
  },
  {
    name: PalletOneJR768VKLhaMeta?.name ?? "franchise-components-pallet-PalletOne___ru",
    path: PalletOneJR768VKLhaMeta?.path ?? "/ru/franchise/components/pallet/PalletOne",
    meta: PalletOneJR768VKLhaMeta || {},
    alias: PalletOneJR768VKLhaMeta?.alias || [],
    redirect: PalletOneJR768VKLhaMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pallet/PalletOne.vue").then(m => m.default || m)
  },
  {
    name: BlockDescriptionfaqVLxCmSuMeta?.name ?? "franchise-components-partnerBlock-BlockDescription___hy",
    path: BlockDescriptionfaqVLxCmSuMeta?.path ?? "/franchise/components/partnerBlock/BlockDescription",
    meta: BlockDescriptionfaqVLxCmSuMeta || {},
    alias: BlockDescriptionfaqVLxCmSuMeta?.alias || [],
    redirect: BlockDescriptionfaqVLxCmSuMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue").then(m => m.default || m)
  },
  {
    name: BlockDescriptionfaqVLxCmSuMeta?.name ?? "franchise-components-partnerBlock-BlockDescription___en",
    path: BlockDescriptionfaqVLxCmSuMeta?.path ?? "/en/franchise/components/partnerBlock/BlockDescription",
    meta: BlockDescriptionfaqVLxCmSuMeta || {},
    alias: BlockDescriptionfaqVLxCmSuMeta?.alias || [],
    redirect: BlockDescriptionfaqVLxCmSuMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue").then(m => m.default || m)
  },
  {
    name: BlockDescriptionfaqVLxCmSuMeta?.name ?? "franchise-components-partnerBlock-BlockDescription___ru",
    path: BlockDescriptionfaqVLxCmSuMeta?.path ?? "/ru/franchise/components/partnerBlock/BlockDescription",
    meta: BlockDescriptionfaqVLxCmSuMeta || {},
    alias: BlockDescriptionfaqVLxCmSuMeta?.alias || [],
    redirect: BlockDescriptionfaqVLxCmSuMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue").then(m => m.default || m)
  },
  {
    name: PartnersBlock1AAZWGAPbGMeta?.name ?? "franchise-components-partnerBlock-PartnersBlock___hy",
    path: PartnersBlock1AAZWGAPbGMeta?.path ?? "/franchise/components/partnerBlock/PartnersBlock",
    meta: PartnersBlock1AAZWGAPbGMeta || {},
    alias: PartnersBlock1AAZWGAPbGMeta?.alias || [],
    redirect: PartnersBlock1AAZWGAPbGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue").then(m => m.default || m)
  },
  {
    name: PartnersBlock1AAZWGAPbGMeta?.name ?? "franchise-components-partnerBlock-PartnersBlock___en",
    path: PartnersBlock1AAZWGAPbGMeta?.path ?? "/en/franchise/components/partnerBlock/PartnersBlock",
    meta: PartnersBlock1AAZWGAPbGMeta || {},
    alias: PartnersBlock1AAZWGAPbGMeta?.alias || [],
    redirect: PartnersBlock1AAZWGAPbGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue").then(m => m.default || m)
  },
  {
    name: PartnersBlock1AAZWGAPbGMeta?.name ?? "franchise-components-partnerBlock-PartnersBlock___ru",
    path: PartnersBlock1AAZWGAPbGMeta?.path ?? "/ru/franchise/components/partnerBlock/PartnersBlock",
    meta: PartnersBlock1AAZWGAPbGMeta || {},
    alias: PartnersBlock1AAZWGAPbGMeta?.alias || [],
    redirect: PartnersBlock1AAZWGAPbGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockdowxSBIKdNMeta?.name ?? "franchise-components-pekPlus-PalletBlock___hy",
    path: PalletBlockdowxSBIKdNMeta?.path ?? "/franchise/components/pekPlus/PalletBlock",
    meta: PalletBlockdowxSBIKdNMeta || {},
    alias: PalletBlockdowxSBIKdNMeta?.alias || [],
    redirect: PalletBlockdowxSBIKdNMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockdowxSBIKdNMeta?.name ?? "franchise-components-pekPlus-PalletBlock___en",
    path: PalletBlockdowxSBIKdNMeta?.path ?? "/en/franchise/components/pekPlus/PalletBlock",
    meta: PalletBlockdowxSBIKdNMeta || {},
    alias: PalletBlockdowxSBIKdNMeta?.alias || [],
    redirect: PalletBlockdowxSBIKdNMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockdowxSBIKdNMeta?.name ?? "franchise-components-pekPlus-PalletBlock___ru",
    path: PalletBlockdowxSBIKdNMeta?.path ?? "/ru/franchise/components/pekPlus/PalletBlock",
    meta: PalletBlockdowxSBIKdNMeta || {},
    alias: PalletBlockdowxSBIKdNMeta?.alias || [],
    redirect: PalletBlockdowxSBIKdNMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PekPlusBlockA2BR9lLQYCMeta?.name ?? "franchise-components-pekPlus-PekPlusBlock___hy",
    path: PekPlusBlockA2BR9lLQYCMeta?.path ?? "/franchise/components/pekPlus/PekPlusBlock",
    meta: PekPlusBlockA2BR9lLQYCMeta || {},
    alias: PekPlusBlockA2BR9lLQYCMeta?.alias || [],
    redirect: PekPlusBlockA2BR9lLQYCMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue").then(m => m.default || m)
  },
  {
    name: PekPlusBlockA2BR9lLQYCMeta?.name ?? "franchise-components-pekPlus-PekPlusBlock___en",
    path: PekPlusBlockA2BR9lLQYCMeta?.path ?? "/en/franchise/components/pekPlus/PekPlusBlock",
    meta: PekPlusBlockA2BR9lLQYCMeta || {},
    alias: PekPlusBlockA2BR9lLQYCMeta?.alias || [],
    redirect: PekPlusBlockA2BR9lLQYCMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue").then(m => m.default || m)
  },
  {
    name: PekPlusBlockA2BR9lLQYCMeta?.name ?? "franchise-components-pekPlus-PekPlusBlock___ru",
    path: PekPlusBlockA2BR9lLQYCMeta?.path ?? "/ru/franchise/components/pekPlus/PekPlusBlock",
    meta: PekPlusBlockA2BR9lLQYCMeta || {},
    alias: PekPlusBlockA2BR9lLQYCMeta?.alias || [],
    redirect: PekPlusBlockA2BR9lLQYCMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue").then(m => m.default || m)
  },
  {
    name: indexo4gH0Sk3DRMeta?.name ?? "franchise___hy",
    path: indexo4gH0Sk3DRMeta?.path ?? "/franchise",
    meta: indexo4gH0Sk3DRMeta || {},
    alias: indexo4gH0Sk3DRMeta?.alias || [],
    redirect: indexo4gH0Sk3DRMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/index.vue").then(m => m.default || m)
  },
  {
    name: indexo4gH0Sk3DRMeta?.name ?? "franchise___en",
    path: indexo4gH0Sk3DRMeta?.path ?? "/en/franchise",
    meta: indexo4gH0Sk3DRMeta || {},
    alias: indexo4gH0Sk3DRMeta?.alias || [],
    redirect: indexo4gH0Sk3DRMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/index.vue").then(m => m.default || m)
  },
  {
    name: indexo4gH0Sk3DRMeta?.name ?? "franchise___ru",
    path: indexo4gH0Sk3DRMeta?.path ?? "/ru/franchise",
    meta: indexo4gH0Sk3DRMeta || {},
    alias: indexo4gH0Sk3DRMeta?.alias || [],
    redirect: indexo4gH0Sk3DRMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/franchise/index.vue").then(m => m.default || m)
  },
  {
    name: AdvantageBlockAH0EVuhcHGMeta?.name ?? "index-components-AdvantageBlock___hy",
    path: AdvantageBlockAH0EVuhcHGMeta?.path ?? "//components/AdvantageBlock",
    meta: AdvantageBlockAH0EVuhcHGMeta || {},
    alias: AdvantageBlockAH0EVuhcHGMeta?.alias || [],
    redirect: AdvantageBlockAH0EVuhcHGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/AdvantageBlock.vue").then(m => m.default || m)
  },
  {
    name: AdvantageBlockAH0EVuhcHGMeta?.name ?? "index-components-AdvantageBlock___en",
    path: AdvantageBlockAH0EVuhcHGMeta?.path ?? "/en//components/AdvantageBlock",
    meta: AdvantageBlockAH0EVuhcHGMeta || {},
    alias: AdvantageBlockAH0EVuhcHGMeta?.alias || [],
    redirect: AdvantageBlockAH0EVuhcHGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/AdvantageBlock.vue").then(m => m.default || m)
  },
  {
    name: AdvantageBlockAH0EVuhcHGMeta?.name ?? "index-components-AdvantageBlock___ru",
    path: AdvantageBlockAH0EVuhcHGMeta?.path ?? "/ru//components/AdvantageBlock",
    meta: AdvantageBlockAH0EVuhcHGMeta || {},
    alias: AdvantageBlockAH0EVuhcHGMeta?.alias || [],
    redirect: AdvantageBlockAH0EVuhcHGMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/AdvantageBlock.vue").then(m => m.default || m)
  },
  {
    name: BannerSliderNxg8kW4CTzMeta?.name ?? "index-components-BannerSlider___hy",
    path: BannerSliderNxg8kW4CTzMeta?.path ?? "//components/BannerSlider",
    meta: BannerSliderNxg8kW4CTzMeta || {},
    alias: BannerSliderNxg8kW4CTzMeta?.alias || [],
    redirect: BannerSliderNxg8kW4CTzMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/BannerSlider.vue").then(m => m.default || m)
  },
  {
    name: BannerSliderNxg8kW4CTzMeta?.name ?? "index-components-BannerSlider___en",
    path: BannerSliderNxg8kW4CTzMeta?.path ?? "/en//components/BannerSlider",
    meta: BannerSliderNxg8kW4CTzMeta || {},
    alias: BannerSliderNxg8kW4CTzMeta?.alias || [],
    redirect: BannerSliderNxg8kW4CTzMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/BannerSlider.vue").then(m => m.default || m)
  },
  {
    name: BannerSliderNxg8kW4CTzMeta?.name ?? "index-components-BannerSlider___ru",
    path: BannerSliderNxg8kW4CTzMeta?.path ?? "/ru//components/BannerSlider",
    meta: BannerSliderNxg8kW4CTzMeta || {},
    alias: BannerSliderNxg8kW4CTzMeta?.alias || [],
    redirect: BannerSliderNxg8kW4CTzMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/BannerSlider.vue").then(m => m.default || m)
  },
  {
    name: BlockTitlevPbBXcQ4u4Meta?.name ?? "index-components-BlockTitle___hy",
    path: BlockTitlevPbBXcQ4u4Meta?.path ?? "//components/BlockTitle",
    meta: BlockTitlevPbBXcQ4u4Meta || {},
    alias: BlockTitlevPbBXcQ4u4Meta?.alias || [],
    redirect: BlockTitlevPbBXcQ4u4Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/BlockTitle.vue").then(m => m.default || m)
  },
  {
    name: BlockTitlevPbBXcQ4u4Meta?.name ?? "index-components-BlockTitle___en",
    path: BlockTitlevPbBXcQ4u4Meta?.path ?? "/en//components/BlockTitle",
    meta: BlockTitlevPbBXcQ4u4Meta || {},
    alias: BlockTitlevPbBXcQ4u4Meta?.alias || [],
    redirect: BlockTitlevPbBXcQ4u4Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/BlockTitle.vue").then(m => m.default || m)
  },
  {
    name: BlockTitlevPbBXcQ4u4Meta?.name ?? "index-components-BlockTitle___ru",
    path: BlockTitlevPbBXcQ4u4Meta?.path ?? "/ru//components/BlockTitle",
    meta: BlockTitlevPbBXcQ4u4Meta || {},
    alias: BlockTitlevPbBXcQ4u4Meta?.alias || [],
    redirect: BlockTitlevPbBXcQ4u4Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/BlockTitle.vue").then(m => m.default || m)
  },
  {
    name: ConsultationBlockOo4EUPyGMRMeta?.name ?? "index-components-ConsultationBlock___hy",
    path: ConsultationBlockOo4EUPyGMRMeta?.path ?? "//components/ConsultationBlock",
    meta: ConsultationBlockOo4EUPyGMRMeta || {},
    alias: ConsultationBlockOo4EUPyGMRMeta?.alias || [],
    redirect: ConsultationBlockOo4EUPyGMRMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ConsultationBlock.vue").then(m => m.default || m)
  },
  {
    name: ConsultationBlockOo4EUPyGMRMeta?.name ?? "index-components-ConsultationBlock___en",
    path: ConsultationBlockOo4EUPyGMRMeta?.path ?? "/en//components/ConsultationBlock",
    meta: ConsultationBlockOo4EUPyGMRMeta || {},
    alias: ConsultationBlockOo4EUPyGMRMeta?.alias || [],
    redirect: ConsultationBlockOo4EUPyGMRMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ConsultationBlock.vue").then(m => m.default || m)
  },
  {
    name: ConsultationBlockOo4EUPyGMRMeta?.name ?? "index-components-ConsultationBlock___ru",
    path: ConsultationBlockOo4EUPyGMRMeta?.path ?? "/ru//components/ConsultationBlock",
    meta: ConsultationBlockOo4EUPyGMRMeta || {},
    alias: ConsultationBlockOo4EUPyGMRMeta?.alias || [],
    redirect: ConsultationBlockOo4EUPyGMRMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ConsultationBlock.vue").then(m => m.default || m)
  },
  {
    name: ConsultationFormamZTqFcpLvMeta?.name ?? "index-components-ConsultationForm___hy",
    path: ConsultationFormamZTqFcpLvMeta?.path ?? "//components/ConsultationForm",
    meta: ConsultationFormamZTqFcpLvMeta || {},
    alias: ConsultationFormamZTqFcpLvMeta?.alias || [],
    redirect: ConsultationFormamZTqFcpLvMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ConsultationForm.vue").then(m => m.default || m)
  },
  {
    name: ConsultationFormamZTqFcpLvMeta?.name ?? "index-components-ConsultationForm___en",
    path: ConsultationFormamZTqFcpLvMeta?.path ?? "/en//components/ConsultationForm",
    meta: ConsultationFormamZTqFcpLvMeta || {},
    alias: ConsultationFormamZTqFcpLvMeta?.alias || [],
    redirect: ConsultationFormamZTqFcpLvMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ConsultationForm.vue").then(m => m.default || m)
  },
  {
    name: ConsultationFormamZTqFcpLvMeta?.name ?? "index-components-ConsultationForm___ru",
    path: ConsultationFormamZTqFcpLvMeta?.path ?? "/ru//components/ConsultationForm",
    meta: ConsultationFormamZTqFcpLvMeta || {},
    alias: ConsultationFormamZTqFcpLvMeta?.alias || [],
    redirect: ConsultationFormamZTqFcpLvMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ConsultationForm.vue").then(m => m.default || m)
  },
  {
    name: ModalErrorw8eQtoZ2pMMeta?.name ?? "index-components-ModalError___hy",
    path: ModalErrorw8eQtoZ2pMMeta?.path ?? "//components/ModalError",
    meta: ModalErrorw8eQtoZ2pMMeta || {},
    alias: ModalErrorw8eQtoZ2pMMeta?.alias || [],
    redirect: ModalErrorw8eQtoZ2pMMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ModalError.vue").then(m => m.default || m)
  },
  {
    name: ModalErrorw8eQtoZ2pMMeta?.name ?? "index-components-ModalError___en",
    path: ModalErrorw8eQtoZ2pMMeta?.path ?? "/en//components/ModalError",
    meta: ModalErrorw8eQtoZ2pMMeta || {},
    alias: ModalErrorw8eQtoZ2pMMeta?.alias || [],
    redirect: ModalErrorw8eQtoZ2pMMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ModalError.vue").then(m => m.default || m)
  },
  {
    name: ModalErrorw8eQtoZ2pMMeta?.name ?? "index-components-ModalError___ru",
    path: ModalErrorw8eQtoZ2pMMeta?.path ?? "/ru//components/ModalError",
    meta: ModalErrorw8eQtoZ2pMMeta || {},
    alias: ModalErrorw8eQtoZ2pMMeta?.alias || [],
    redirect: ModalErrorw8eQtoZ2pMMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ModalError.vue").then(m => m.default || m)
  },
  {
    name: ModalSuccessUUfJgxVefbMeta?.name ?? "index-components-ModalSuccess___hy",
    path: ModalSuccessUUfJgxVefbMeta?.path ?? "//components/ModalSuccess",
    meta: ModalSuccessUUfJgxVefbMeta || {},
    alias: ModalSuccessUUfJgxVefbMeta?.alias || [],
    redirect: ModalSuccessUUfJgxVefbMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ModalSuccess.vue").then(m => m.default || m)
  },
  {
    name: ModalSuccessUUfJgxVefbMeta?.name ?? "index-components-ModalSuccess___en",
    path: ModalSuccessUUfJgxVefbMeta?.path ?? "/en//components/ModalSuccess",
    meta: ModalSuccessUUfJgxVefbMeta || {},
    alias: ModalSuccessUUfJgxVefbMeta?.alias || [],
    redirect: ModalSuccessUUfJgxVefbMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ModalSuccess.vue").then(m => m.default || m)
  },
  {
    name: ModalSuccessUUfJgxVefbMeta?.name ?? "index-components-ModalSuccess___ru",
    path: ModalSuccessUUfJgxVefbMeta?.path ?? "/ru//components/ModalSuccess",
    meta: ModalSuccessUUfJgxVefbMeta || {},
    alias: ModalSuccessUUfJgxVefbMeta?.alias || [],
    redirect: ModalSuccessUUfJgxVefbMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/components/ModalSuccess.vue").then(m => m.default || m)
  },
  {
    name: indexQki3eD8v5aMeta?.name ?? "index___hy",
    path: indexQki3eD8v5aMeta?.path ?? "/",
    meta: indexQki3eD8v5aMeta || {},
    alias: indexQki3eD8v5aMeta?.alias || [],
    redirect: indexQki3eD8v5aMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: indexQki3eD8v5aMeta?.name ?? "index___en",
    path: indexQki3eD8v5aMeta?.path ?? "/en",
    meta: indexQki3eD8v5aMeta || {},
    alias: indexQki3eD8v5aMeta?.alias || [],
    redirect: indexQki3eD8v5aMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: indexQki3eD8v5aMeta?.name ?? "index___ru",
    path: indexQki3eD8v5aMeta?.path ?? "/ru",
    meta: indexQki3eD8v5aMeta || {},
    alias: indexQki3eD8v5aMeta?.alias || [],
    redirect: indexQki3eD8v5aMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/index.vue").then(m => m.default || m)
  },
  {
    name: DefaultAdvantagesSection1AFZ6zFr1zMeta?.name ?? "index-sections-DefaultAdvantagesSection___hy",
    path: DefaultAdvantagesSection1AFZ6zFr1zMeta?.path ?? "//sections/DefaultAdvantagesSection",
    meta: DefaultAdvantagesSection1AFZ6zFr1zMeta || {},
    alias: DefaultAdvantagesSection1AFZ6zFr1zMeta?.alias || [],
    redirect: DefaultAdvantagesSection1AFZ6zFr1zMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue").then(m => m.default || m)
  },
  {
    name: DefaultAdvantagesSection1AFZ6zFr1zMeta?.name ?? "index-sections-DefaultAdvantagesSection___en",
    path: DefaultAdvantagesSection1AFZ6zFr1zMeta?.path ?? "/en//sections/DefaultAdvantagesSection",
    meta: DefaultAdvantagesSection1AFZ6zFr1zMeta || {},
    alias: DefaultAdvantagesSection1AFZ6zFr1zMeta?.alias || [],
    redirect: DefaultAdvantagesSection1AFZ6zFr1zMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue").then(m => m.default || m)
  },
  {
    name: DefaultAdvantagesSection1AFZ6zFr1zMeta?.name ?? "index-sections-DefaultAdvantagesSection___ru",
    path: DefaultAdvantagesSection1AFZ6zFr1zMeta?.path ?? "/ru//sections/DefaultAdvantagesSection",
    meta: DefaultAdvantagesSection1AFZ6zFr1zMeta || {},
    alias: DefaultAdvantagesSection1AFZ6zFr1zMeta?.alias || [],
    redirect: DefaultAdvantagesSection1AFZ6zFr1zMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue").then(m => m.default || m)
  },
  {
    name: DefaultHeaderSectionudrYYBu1sOMeta?.name ?? "index-sections-DefaultHeaderSection___hy",
    path: DefaultHeaderSectionudrYYBu1sOMeta?.path ?? "//sections/DefaultHeaderSection",
    meta: DefaultHeaderSectionudrYYBu1sOMeta || {},
    alias: DefaultHeaderSectionudrYYBu1sOMeta?.alias || [],
    redirect: DefaultHeaderSectionudrYYBu1sOMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DefaultHeaderSection.vue").then(m => m.default || m)
  },
  {
    name: DefaultHeaderSectionudrYYBu1sOMeta?.name ?? "index-sections-DefaultHeaderSection___en",
    path: DefaultHeaderSectionudrYYBu1sOMeta?.path ?? "/en//sections/DefaultHeaderSection",
    meta: DefaultHeaderSectionudrYYBu1sOMeta || {},
    alias: DefaultHeaderSectionudrYYBu1sOMeta?.alias || [],
    redirect: DefaultHeaderSectionudrYYBu1sOMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DefaultHeaderSection.vue").then(m => m.default || m)
  },
  {
    name: DefaultHeaderSectionudrYYBu1sOMeta?.name ?? "index-sections-DefaultHeaderSection___ru",
    path: DefaultHeaderSectionudrYYBu1sOMeta?.path ?? "/ru//sections/DefaultHeaderSection",
    meta: DefaultHeaderSectionudrYYBu1sOMeta || {},
    alias: DefaultHeaderSectionudrYYBu1sOMeta?.alias || [],
    redirect: DefaultHeaderSectionudrYYBu1sOMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DefaultHeaderSection.vue").then(m => m.default || m)
  },
  {
    name: DescriptionSectionSg4nfRLbdDMeta?.name ?? "index-sections-DescriptionSection___hy",
    path: DescriptionSectionSg4nfRLbdDMeta?.path ?? "//sections/DescriptionSection",
    meta: DescriptionSectionSg4nfRLbdDMeta || {},
    alias: DescriptionSectionSg4nfRLbdDMeta?.alias || [],
    redirect: DescriptionSectionSg4nfRLbdDMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DescriptionSection.vue").then(m => m.default || m)
  },
  {
    name: DescriptionSectionSg4nfRLbdDMeta?.name ?? "index-sections-DescriptionSection___en",
    path: DescriptionSectionSg4nfRLbdDMeta?.path ?? "/en//sections/DescriptionSection",
    meta: DescriptionSectionSg4nfRLbdDMeta || {},
    alias: DescriptionSectionSg4nfRLbdDMeta?.alias || [],
    redirect: DescriptionSectionSg4nfRLbdDMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DescriptionSection.vue").then(m => m.default || m)
  },
  {
    name: DescriptionSectionSg4nfRLbdDMeta?.name ?? "index-sections-DescriptionSection___ru",
    path: DescriptionSectionSg4nfRLbdDMeta?.path ?? "/ru//sections/DescriptionSection",
    meta: DescriptionSectionSg4nfRLbdDMeta || {},
    alias: DescriptionSectionSg4nfRLbdDMeta?.alias || [],
    redirect: DescriptionSectionSg4nfRLbdDMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/DescriptionSection.vue").then(m => m.default || m)
  },
  {
    name: FaqSectionNxUCLl004aMeta?.name ?? "index-sections-FaqSection___hy",
    path: FaqSectionNxUCLl004aMeta?.path ?? "//sections/FaqSection",
    meta: FaqSectionNxUCLl004aMeta || {},
    alias: FaqSectionNxUCLl004aMeta?.alias || [],
    redirect: FaqSectionNxUCLl004aMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/FaqSection.vue").then(m => m.default || m)
  },
  {
    name: FaqSectionNxUCLl004aMeta?.name ?? "index-sections-FaqSection___en",
    path: FaqSectionNxUCLl004aMeta?.path ?? "/en//sections/FaqSection",
    meta: FaqSectionNxUCLl004aMeta || {},
    alias: FaqSectionNxUCLl004aMeta?.alias || [],
    redirect: FaqSectionNxUCLl004aMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/FaqSection.vue").then(m => m.default || m)
  },
  {
    name: FaqSectionNxUCLl004aMeta?.name ?? "index-sections-FaqSection___ru",
    path: FaqSectionNxUCLl004aMeta?.path ?? "/ru//sections/FaqSection",
    meta: FaqSectionNxUCLl004aMeta || {},
    alias: FaqSectionNxUCLl004aMeta?.alias || [],
    redirect: FaqSectionNxUCLl004aMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/FaqSection.vue").then(m => m.default || m)
  },
  {
    name: InfoSectionrI6mYqJstZMeta?.name ?? "index-sections-InfoSection___hy",
    path: InfoSectionrI6mYqJstZMeta?.path ?? "//sections/InfoSection",
    meta: InfoSectionrI6mYqJstZMeta || {},
    alias: InfoSectionrI6mYqJstZMeta?.alias || [],
    redirect: InfoSectionrI6mYqJstZMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/InfoSection.vue").then(m => m.default || m)
  },
  {
    name: InfoSectionrI6mYqJstZMeta?.name ?? "index-sections-InfoSection___en",
    path: InfoSectionrI6mYqJstZMeta?.path ?? "/en//sections/InfoSection",
    meta: InfoSectionrI6mYqJstZMeta || {},
    alias: InfoSectionrI6mYqJstZMeta?.alias || [],
    redirect: InfoSectionrI6mYqJstZMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/InfoSection.vue").then(m => m.default || m)
  },
  {
    name: InfoSectionrI6mYqJstZMeta?.name ?? "index-sections-InfoSection___ru",
    path: InfoSectionrI6mYqJstZMeta?.path ?? "/ru//sections/InfoSection",
    meta: InfoSectionrI6mYqJstZMeta || {},
    alias: InfoSectionrI6mYqJstZMeta?.alias || [],
    redirect: InfoSectionrI6mYqJstZMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/InfoSection.vue").then(m => m.default || m)
  },
  {
    name: MapSection9FYkEwe3gNMeta?.name ?? "index-sections-MapSection___hy",
    path: MapSection9FYkEwe3gNMeta?.path ?? "//sections/MapSection",
    meta: MapSection9FYkEwe3gNMeta || {},
    alias: MapSection9FYkEwe3gNMeta?.alias || [],
    redirect: MapSection9FYkEwe3gNMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/MapSection.vue").then(m => m.default || m)
  },
  {
    name: MapSection9FYkEwe3gNMeta?.name ?? "index-sections-MapSection___en",
    path: MapSection9FYkEwe3gNMeta?.path ?? "/en//sections/MapSection",
    meta: MapSection9FYkEwe3gNMeta || {},
    alias: MapSection9FYkEwe3gNMeta?.alias || [],
    redirect: MapSection9FYkEwe3gNMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/MapSection.vue").then(m => m.default || m)
  },
  {
    name: MapSection9FYkEwe3gNMeta?.name ?? "index-sections-MapSection___ru",
    path: MapSection9FYkEwe3gNMeta?.path ?? "/ru//sections/MapSection",
    meta: MapSection9FYkEwe3gNMeta || {},
    alias: MapSection9FYkEwe3gNMeta?.alias || [],
    redirect: MapSection9FYkEwe3gNMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/sections/MapSection.vue").then(m => m.default || m)
  },
  {
    name: getAddressInfohkZLymObShMeta?.name ?? "index-utils-getAddressInfo___hy",
    path: getAddressInfohkZLymObShMeta?.path ?? "//utils/getAddressInfo",
    meta: getAddressInfohkZLymObShMeta || {},
    alias: getAddressInfohkZLymObShMeta?.alias || [],
    redirect: getAddressInfohkZLymObShMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getAddressInfo.js").then(m => m.default || m)
  },
  {
    name: getAddressInfohkZLymObShMeta?.name ?? "index-utils-getAddressInfo___en",
    path: getAddressInfohkZLymObShMeta?.path ?? "/en//utils/getAddressInfo",
    meta: getAddressInfohkZLymObShMeta || {},
    alias: getAddressInfohkZLymObShMeta?.alias || [],
    redirect: getAddressInfohkZLymObShMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getAddressInfo.js").then(m => m.default || m)
  },
  {
    name: getAddressInfohkZLymObShMeta?.name ?? "index-utils-getAddressInfo___ru",
    path: getAddressInfohkZLymObShMeta?.path ?? "/ru//utils/getAddressInfo",
    meta: getAddressInfohkZLymObShMeta || {},
    alias: getAddressInfohkZLymObShMeta?.alias || [],
    redirect: getAddressInfohkZLymObShMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getAddressInfo.js").then(m => m.default || m)
  },
  {
    name: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.name ?? "index-utils-getDirectionParamsFromAddressInfo___hy",
    path: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.path ?? "//utils/getDirectionParamsFromAddressInfo",
    meta: getDirectionParamsFromAddressInfoWMpkquWxkhMeta || {},
    alias: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.alias || [],
    redirect: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js").then(m => m.default || m)
  },
  {
    name: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.name ?? "index-utils-getDirectionParamsFromAddressInfo___en",
    path: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.path ?? "/en//utils/getDirectionParamsFromAddressInfo",
    meta: getDirectionParamsFromAddressInfoWMpkquWxkhMeta || {},
    alias: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.alias || [],
    redirect: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js").then(m => m.default || m)
  },
  {
    name: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.name ?? "index-utils-getDirectionParamsFromAddressInfo___ru",
    path: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.path ?? "/ru//utils/getDirectionParamsFromAddressInfo",
    meta: getDirectionParamsFromAddressInfoWMpkquWxkhMeta || {},
    alias: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.alias || [],
    redirect: getDirectionParamsFromAddressInfoWMpkquWxkhMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js").then(m => m.default || m)
  },
  {
    name: getNeedCalculatelIKzwVQrXQMeta?.name ?? "index-utils-getNeedCalculate___hy",
    path: getNeedCalculatelIKzwVQrXQMeta?.path ?? "//utils/getNeedCalculate",
    meta: getNeedCalculatelIKzwVQrXQMeta || {},
    alias: getNeedCalculatelIKzwVQrXQMeta?.alias || [],
    redirect: getNeedCalculatelIKzwVQrXQMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getNeedCalculate.js").then(m => m.default || m)
  },
  {
    name: getNeedCalculatelIKzwVQrXQMeta?.name ?? "index-utils-getNeedCalculate___en",
    path: getNeedCalculatelIKzwVQrXQMeta?.path ?? "/en//utils/getNeedCalculate",
    meta: getNeedCalculatelIKzwVQrXQMeta || {},
    alias: getNeedCalculatelIKzwVQrXQMeta?.alias || [],
    redirect: getNeedCalculatelIKzwVQrXQMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getNeedCalculate.js").then(m => m.default || m)
  },
  {
    name: getNeedCalculatelIKzwVQrXQMeta?.name ?? "index-utils-getNeedCalculate___ru",
    path: getNeedCalculatelIKzwVQrXQMeta?.path ?? "/ru//utils/getNeedCalculate",
    meta: getNeedCalculatelIKzwVQrXQMeta || {},
    alias: getNeedCalculatelIKzwVQrXQMeta?.alias || [],
    redirect: getNeedCalculatelIKzwVQrXQMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getNeedCalculate.js").then(m => m.default || m)
  },
  {
    name: getSugggestAmwz4bznMkMeta?.name ?? "index-utils-getSugggest___hy",
    path: getSugggestAmwz4bznMkMeta?.path ?? "//utils/getSugggest",
    meta: getSugggestAmwz4bznMkMeta || {},
    alias: getSugggestAmwz4bznMkMeta?.alias || [],
    redirect: getSugggestAmwz4bznMkMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getSugggest.js").then(m => m.default || m)
  },
  {
    name: getSugggestAmwz4bznMkMeta?.name ?? "index-utils-getSugggest___en",
    path: getSugggestAmwz4bznMkMeta?.path ?? "/en//utils/getSugggest",
    meta: getSugggestAmwz4bznMkMeta || {},
    alias: getSugggestAmwz4bznMkMeta?.alias || [],
    redirect: getSugggestAmwz4bznMkMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getSugggest.js").then(m => m.default || m)
  },
  {
    name: getSugggestAmwz4bznMkMeta?.name ?? "index-utils-getSugggest___ru",
    path: getSugggestAmwz4bznMkMeta?.path ?? "/ru//utils/getSugggest",
    meta: getSugggestAmwz4bznMkMeta || {},
    alias: getSugggestAmwz4bznMkMeta?.alias || [],
    redirect: getSugggestAmwz4bznMkMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getSugggest.js").then(m => m.default || m)
  },
  {
    name: getTransitCostBlockMessageRqeVp9RWiQMeta?.name ?? "index-utils-getTransitCostBlockMessage___hy",
    path: getTransitCostBlockMessageRqeVp9RWiQMeta?.path ?? "//utils/getTransitCostBlockMessage",
    meta: getTransitCostBlockMessageRqeVp9RWiQMeta || {},
    alias: getTransitCostBlockMessageRqeVp9RWiQMeta?.alias || [],
    redirect: getTransitCostBlockMessageRqeVp9RWiQMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getTransitCostBlockMessage.js").then(m => m.default || m)
  },
  {
    name: getTransitCostBlockMessageRqeVp9RWiQMeta?.name ?? "index-utils-getTransitCostBlockMessage___en",
    path: getTransitCostBlockMessageRqeVp9RWiQMeta?.path ?? "/en//utils/getTransitCostBlockMessage",
    meta: getTransitCostBlockMessageRqeVp9RWiQMeta || {},
    alias: getTransitCostBlockMessageRqeVp9RWiQMeta?.alias || [],
    redirect: getTransitCostBlockMessageRqeVp9RWiQMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getTransitCostBlockMessage.js").then(m => m.default || m)
  },
  {
    name: getTransitCostBlockMessageRqeVp9RWiQMeta?.name ?? "index-utils-getTransitCostBlockMessage___ru",
    path: getTransitCostBlockMessageRqeVp9RWiQMeta?.path ?? "/ru//utils/getTransitCostBlockMessage",
    meta: getTransitCostBlockMessageRqeVp9RWiQMeta || {},
    alias: getTransitCostBlockMessageRqeVp9RWiQMeta?.alias || [],
    redirect: getTransitCostBlockMessageRqeVp9RWiQMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/getTransitCostBlockMessage.js").then(m => m.default || m)
  },
  {
    name: isProductCodeU4uiEf2eXpMeta?.name ?? "index-utils-isProductCode___hy",
    path: isProductCodeU4uiEf2eXpMeta?.path ?? "//utils/isProductCode",
    meta: isProductCodeU4uiEf2eXpMeta || {},
    alias: isProductCodeU4uiEf2eXpMeta?.alias || [],
    redirect: isProductCodeU4uiEf2eXpMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/isProductCode.js").then(m => m.default || m)
  },
  {
    name: isProductCodeU4uiEf2eXpMeta?.name ?? "index-utils-isProductCode___en",
    path: isProductCodeU4uiEf2eXpMeta?.path ?? "/en//utils/isProductCode",
    meta: isProductCodeU4uiEf2eXpMeta || {},
    alias: isProductCodeU4uiEf2eXpMeta?.alias || [],
    redirect: isProductCodeU4uiEf2eXpMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/isProductCode.js").then(m => m.default || m)
  },
  {
    name: isProductCodeU4uiEf2eXpMeta?.name ?? "index-utils-isProductCode___ru",
    path: isProductCodeU4uiEf2eXpMeta?.path ?? "/ru//utils/isProductCode",
    meta: isProductCodeU4uiEf2eXpMeta || {},
    alias: isProductCodeU4uiEf2eXpMeta?.alias || [],
    redirect: isProductCodeU4uiEf2eXpMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/index/utils/isProductCode.js").then(m => m.default || m)
  },
  {
    name: _91id_9372B1km1bFBMeta?.name ?? "news-id___hy",
    path: _91id_9372B1km1bFBMeta?.path ?? "/news/:id()",
    meta: _91id_9372B1km1bFBMeta || {},
    alias: _91id_9372B1km1bFBMeta?.alias || [],
    redirect: _91id_9372B1km1bFBMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_9372B1km1bFBMeta?.name ?? "news-id___en",
    path: _91id_9372B1km1bFBMeta?.path ?? "/en/news/:id()",
    meta: _91id_9372B1km1bFBMeta || {},
    alias: _91id_9372B1km1bFBMeta?.alias || [],
    redirect: _91id_9372B1km1bFBMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_9372B1km1bFBMeta?.name ?? "news-id___ru",
    path: _91id_9372B1km1bFBMeta?.path ?? "/ru/news/:id()",
    meta: _91id_9372B1km1bFBMeta || {},
    alias: _91id_9372B1km1bFBMeta?.alias || [],
    redirect: _91id_9372B1km1bFBMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: indexCgQk0w04xcMeta?.name ?? "news___hy",
    path: indexCgQk0w04xcMeta?.path ?? "/news",
    meta: indexCgQk0w04xcMeta || {},
    alias: indexCgQk0w04xcMeta?.alias || [],
    redirect: indexCgQk0w04xcMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexCgQk0w04xcMeta?.name ?? "news___en",
    path: indexCgQk0w04xcMeta?.path ?? "/en/news",
    meta: indexCgQk0w04xcMeta || {},
    alias: indexCgQk0w04xcMeta?.alias || [],
    redirect: indexCgQk0w04xcMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexCgQk0w04xcMeta?.name ?? "news___ru",
    path: indexCgQk0w04xcMeta?.path ?? "/ru/news",
    meta: indexCgQk0w04xcMeta || {},
    alias: indexCgQk0w04xcMeta?.alias || [],
    redirect: indexCgQk0w04xcMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: Category5o7lwb8Dm8Meta?.name ?? "package-components-Category___hy",
    path: Category5o7lwb8Dm8Meta?.path ?? "/package/components/Category",
    meta: Category5o7lwb8Dm8Meta || {},
    alias: Category5o7lwb8Dm8Meta?.alias || [],
    redirect: Category5o7lwb8Dm8Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/Category.vue").then(m => m.default || m)
  },
  {
    name: Category5o7lwb8Dm8Meta?.name ?? "package-components-Category___en",
    path: Category5o7lwb8Dm8Meta?.path ?? "/en/package/components/Category",
    meta: Category5o7lwb8Dm8Meta || {},
    alias: Category5o7lwb8Dm8Meta?.alias || [],
    redirect: Category5o7lwb8Dm8Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/Category.vue").then(m => m.default || m)
  },
  {
    name: Category5o7lwb8Dm8Meta?.name ?? "package-components-Category___ru",
    path: Category5o7lwb8Dm8Meta?.path ?? "/ru/package/components/Category",
    meta: Category5o7lwb8Dm8Meta || {},
    alias: Category5o7lwb8Dm8Meta?.alias || [],
    redirect: Category5o7lwb8Dm8Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/Category.vue").then(m => m.default || m)
  },
  {
    name: CategoryPalletFWtshR6M0AMeta?.name ?? "package-components-CategoryPallet___hy",
    path: CategoryPalletFWtshR6M0AMeta?.path ?? "/package/components/CategoryPallet",
    meta: CategoryPalletFWtshR6M0AMeta || {},
    alias: CategoryPalletFWtshR6M0AMeta?.alias || [],
    redirect: CategoryPalletFWtshR6M0AMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/CategoryPallet.vue").then(m => m.default || m)
  },
  {
    name: CategoryPalletFWtshR6M0AMeta?.name ?? "package-components-CategoryPallet___en",
    path: CategoryPalletFWtshR6M0AMeta?.path ?? "/en/package/components/CategoryPallet",
    meta: CategoryPalletFWtshR6M0AMeta || {},
    alias: CategoryPalletFWtshR6M0AMeta?.alias || [],
    redirect: CategoryPalletFWtshR6M0AMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/CategoryPallet.vue").then(m => m.default || m)
  },
  {
    name: CategoryPalletFWtshR6M0AMeta?.name ?? "package-components-CategoryPallet___ru",
    path: CategoryPalletFWtshR6M0AMeta?.path ?? "/ru/package/components/CategoryPallet",
    meta: CategoryPalletFWtshR6M0AMeta || {},
    alias: CategoryPalletFWtshR6M0AMeta?.alias || [],
    redirect: CategoryPalletFWtshR6M0AMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/CategoryPallet.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockESgtCrYfKfMeta?.name ?? "package-components-PalletBlock___hy",
    path: PalletBlockESgtCrYfKfMeta?.path ?? "/package/components/PalletBlock",
    meta: PalletBlockESgtCrYfKfMeta || {},
    alias: PalletBlockESgtCrYfKfMeta?.alias || [],
    redirect: PalletBlockESgtCrYfKfMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockESgtCrYfKfMeta?.name ?? "package-components-PalletBlock___en",
    path: PalletBlockESgtCrYfKfMeta?.path ?? "/en/package/components/PalletBlock",
    meta: PalletBlockESgtCrYfKfMeta || {},
    alias: PalletBlockESgtCrYfKfMeta?.alias || [],
    redirect: PalletBlockESgtCrYfKfMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: PalletBlockESgtCrYfKfMeta?.name ?? "package-components-PalletBlock___ru",
    path: PalletBlockESgtCrYfKfMeta?.path ?? "/ru/package/components/PalletBlock",
    meta: PalletBlockESgtCrYfKfMeta || {},
    alias: PalletBlockESgtCrYfKfMeta?.alias || [],
    redirect: PalletBlockESgtCrYfKfMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/PalletBlock.vue").then(m => m.default || m)
  },
  {
    name: HeadWithSearch1wJjSmHIfsMeta?.name ?? "package-components-TableSearch-HeadWithSearch___hy",
    path: HeadWithSearch1wJjSmHIfsMeta?.path ?? "/package/components/TableSearch/HeadWithSearch",
    meta: HeadWithSearch1wJjSmHIfsMeta || {},
    alias: HeadWithSearch1wJjSmHIfsMeta?.alias || [],
    redirect: HeadWithSearch1wJjSmHIfsMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue").then(m => m.default || m)
  },
  {
    name: HeadWithSearch1wJjSmHIfsMeta?.name ?? "package-components-TableSearch-HeadWithSearch___en",
    path: HeadWithSearch1wJjSmHIfsMeta?.path ?? "/en/package/components/TableSearch/HeadWithSearch",
    meta: HeadWithSearch1wJjSmHIfsMeta || {},
    alias: HeadWithSearch1wJjSmHIfsMeta?.alias || [],
    redirect: HeadWithSearch1wJjSmHIfsMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue").then(m => m.default || m)
  },
  {
    name: HeadWithSearch1wJjSmHIfsMeta?.name ?? "package-components-TableSearch-HeadWithSearch___ru",
    path: HeadWithSearch1wJjSmHIfsMeta?.path ?? "/ru/package/components/TableSearch/HeadWithSearch",
    meta: HeadWithSearch1wJjSmHIfsMeta || {},
    alias: HeadWithSearch1wJjSmHIfsMeta?.alias || [],
    redirect: HeadWithSearch1wJjSmHIfsMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue").then(m => m.default || m)
  },
  {
    name: TableBlock3FzEbDyGhgMeta?.name ?? "package-components-TableSearch-TableBlock___hy",
    path: TableBlock3FzEbDyGhgMeta?.path ?? "/package/components/TableSearch/TableBlock",
    meta: TableBlock3FzEbDyGhgMeta || {},
    alias: TableBlock3FzEbDyGhgMeta?.alias || [],
    redirect: TableBlock3FzEbDyGhgMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableBlock.vue").then(m => m.default || m)
  },
  {
    name: TableBlock3FzEbDyGhgMeta?.name ?? "package-components-TableSearch-TableBlock___en",
    path: TableBlock3FzEbDyGhgMeta?.path ?? "/en/package/components/TableSearch/TableBlock",
    meta: TableBlock3FzEbDyGhgMeta || {},
    alias: TableBlock3FzEbDyGhgMeta?.alias || [],
    redirect: TableBlock3FzEbDyGhgMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableBlock.vue").then(m => m.default || m)
  },
  {
    name: TableBlock3FzEbDyGhgMeta?.name ?? "package-components-TableSearch-TableBlock___ru",
    path: TableBlock3FzEbDyGhgMeta?.path ?? "/ru/package/components/TableSearch/TableBlock",
    meta: TableBlock3FzEbDyGhgMeta || {},
    alias: TableBlock3FzEbDyGhgMeta?.alias || [],
    redirect: TableBlock3FzEbDyGhgMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableBlock.vue").then(m => m.default || m)
  },
  {
    name: TableRow0zfH4AUUw3Meta?.name ?? "package-components-TableSearch-TableRow___hy",
    path: TableRow0zfH4AUUw3Meta?.path ?? "/package/components/TableSearch/TableRow",
    meta: TableRow0zfH4AUUw3Meta || {},
    alias: TableRow0zfH4AUUw3Meta?.alias || [],
    redirect: TableRow0zfH4AUUw3Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableRow.vue").then(m => m.default || m)
  },
  {
    name: TableRow0zfH4AUUw3Meta?.name ?? "package-components-TableSearch-TableRow___en",
    path: TableRow0zfH4AUUw3Meta?.path ?? "/en/package/components/TableSearch/TableRow",
    meta: TableRow0zfH4AUUw3Meta || {},
    alias: TableRow0zfH4AUUw3Meta?.alias || [],
    redirect: TableRow0zfH4AUUw3Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableRow.vue").then(m => m.default || m)
  },
  {
    name: TableRow0zfH4AUUw3Meta?.name ?? "package-components-TableSearch-TableRow___ru",
    path: TableRow0zfH4AUUw3Meta?.path ?? "/ru/package/components/TableSearch/TableRow",
    meta: TableRow0zfH4AUUw3Meta || {},
    alias: TableRow0zfH4AUUw3Meta?.alias || [],
    redirect: TableRow0zfH4AUUw3Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableRow.vue").then(m => m.default || m)
  },
  {
    name: TableSearchbGV6TAzil3Meta?.name ?? "package-components-TableSearch-TableSearch___hy",
    path: TableSearchbGV6TAzil3Meta?.path ?? "/package/components/TableSearch/TableSearch",
    meta: TableSearchbGV6TAzil3Meta || {},
    alias: TableSearchbGV6TAzil3Meta?.alias || [],
    redirect: TableSearchbGV6TAzil3Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableSearch.vue").then(m => m.default || m)
  },
  {
    name: TableSearchbGV6TAzil3Meta?.name ?? "package-components-TableSearch-TableSearch___en",
    path: TableSearchbGV6TAzil3Meta?.path ?? "/en/package/components/TableSearch/TableSearch",
    meta: TableSearchbGV6TAzil3Meta || {},
    alias: TableSearchbGV6TAzil3Meta?.alias || [],
    redirect: TableSearchbGV6TAzil3Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableSearch.vue").then(m => m.default || m)
  },
  {
    name: TableSearchbGV6TAzil3Meta?.name ?? "package-components-TableSearch-TableSearch___ru",
    path: TableSearchbGV6TAzil3Meta?.path ?? "/ru/package/components/TableSearch/TableSearch",
    meta: TableSearchbGV6TAzil3Meta || {},
    alias: TableSearchbGV6TAzil3Meta?.alias || [],
    redirect: TableSearchbGV6TAzil3Meta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/components/TableSearch/TableSearch.vue").then(m => m.default || m)
  },
  {
    name: index3iPLGMVd8RMeta?.name ?? "package___hy",
    path: index3iPLGMVd8RMeta?.path ?? "/package",
    meta: index3iPLGMVd8RMeta || {},
    alias: index3iPLGMVd8RMeta?.alias || [],
    redirect: index3iPLGMVd8RMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/index.vue").then(m => m.default || m)
  },
  {
    name: index3iPLGMVd8RMeta?.name ?? "package___en",
    path: index3iPLGMVd8RMeta?.path ?? "/en/package",
    meta: index3iPLGMVd8RMeta || {},
    alias: index3iPLGMVd8RMeta?.alias || [],
    redirect: index3iPLGMVd8RMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/index.vue").then(m => m.default || m)
  },
  {
    name: index3iPLGMVd8RMeta?.name ?? "package___ru",
    path: index3iPLGMVd8RMeta?.path ?? "/ru/package",
    meta: index3iPLGMVd8RMeta || {},
    alias: index3iPLGMVd8RMeta?.alias || [],
    redirect: index3iPLGMVd8RMeta?.redirect || undefined,
    component: () => import("/var/www/pecom.am/www/frontend/pages/package/index.vue").then(m => m.default || m)
  }
]